<template>
  <el-table :data="teams" border>
    <el-table-column prop="Dept" label="部门" />
    <el-table-column prop="Name" label="姓名" />
    <el-table-column prop="Phone" label="电话" />
    <el-table-column width="64px" align="center">
      <el-link slot="header" type="primary" @click="onInvite()">邀请</el-link>
      <template slot-scope="{ row }">
        <el-link type="primary" @click="onRemove(row)">
          {{ oper == row.UserId ? "退出" : "移除" }}
        </el-link>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import userPicker from "@/views/company/branch/staff/_picker.vue";
export default {
  props: {
    demand: { type: String },
  },
  data() {
    return {
      teams: null,
      oper: JSON.parse(localStorage.getItem("user"))?.Id,
    };
  },
  created() {
    if (this.demand) {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      this.$apis.job.demand.team
        .list({
          demand: this.demand,
        })
        .then((res) => {
          this.teams = res;
        });
    },
    //邀请
    onInvite() {
      this.$layer.iframe({
        title: "选择人员",
        area: ["720px", "500px"],
        content: {
          content: userPicker,
          parent: this,
          data: {
            callback: (res = {}) => {
              this.$apis.job.demand.team
                .invite({ UserId: res.Id, DemandId: this.demand })
                .then(() => {
                  this.loadData();
                  this.$message({
                    message: "邀请成功！",
                    type: "success",
                  });
                })
                .catch((e) => {
                  this.$message.error(e);
                });
            },
          },
        },
      });
    },

    //退出
    onQuit(row){
      console.log(row)
    },

    //移除
    onRemove(row) {
      this.$confirm(`此操作将移除成员, 是否继续?`, `移除${row.Name}`, {
        center: true,
      }).then(() => {
        this.$apis.job.demand.team
          .remove({ UserId: row.UserId, DemandId: this.demand })
          .then(() => {
            this.loadData();
            this.$message({ message: "已移除成员！", type: "success" });
          })
          .catch((e) => {
            this.$message.error(e);
          });
      });
    },
  },
};
</script>